// StudentController.js
import BaseController from "src/controller/BaseController.js";
import ApiUrls from "src/routes/api";
import { Api } from "src/utils";
import RestApiClient from "src/utils/RestApiClient";

const api = new RestApiClient();

class Assessment extends BaseController {
  _list = "";

  _get = ApiUrls.assessment.get;

  _post = ApiUrls.assessment.create;

  _put = ApiUrls.assessment.update;

  _delete = ApiUrls.assessment.delete;

  async report(student_id, subject_code) {
    return new Promise((resolve, reject) => {
      api
        .get(
          ApiUrls.student.assessmentsReport(
            student_id,
            encodeURIComponent(subject_code)
          )
        )
        .then((res) => {
          if (res.result) {
            resolve(res.data);
          } else {
          }
        })
        .catch((err) => reject(err));
    });
  }

  async publicReport(student_id, subject_code) {
    return new Promise((resolve, reject) => {
      api
        .get(
          ApiUrls.assessment.publicReport(
            student_id,
            encodeURIComponent(subject_code)
          )
        )
        .then((res) => {
          if (res.result) {
            resolve(res.data);
          } else {
          }
        })
        .catch((err) => reject(err));
    });
  }

  async getPublicLink(data) {
    return new Promise((resolve, reject) => {
      Api.post(ApiUrls.assessment.getPublicLink, data)
        .then((res) => {
          if (res.result) {
            resolve(res.data);
          } else {
            this.handleError(res, reject);
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export default new Assessment();
